const PATH = 'app/Booking';

export const SEND_ADD_NEW_BOOKING_REQUEST = `${PATH}SEND_ADD_NEW_BOOKING_REQUEST`;
